export default class TableBuilderDisplayFilterDropDown {
    
    public static isRegistered = false;
    public static readonly selector = '.general-dropdown';
    public toggled:boolean;

    private element: HTMLElement;

    constructor(element: HTMLElement) {

        this.element = element

        const selectToggle = element.querySelector('.select-all-toggle');
        if (selectToggle) {
            this.toggled = this.element.hasAttribute('data-is-all-selected');
            selectToggle.addEventListener('click', this.onSelectAllToggle);
        }

        const filterInput = <HTMLInputElement> this.element.querySelector('#list-filter');
        if (filterInput)
            filterInput.onkeyup = this.onListFilterKeyUp;

        if (this.element.hasAttribute('data-defaults-to-all')) {
            this.element.addEventListener('change', this.updateInputNames);
            this.updateInputNames();
        }
    }
    
    public static register() {
        if (TableBuilderDisplayFilterDropDown.isRegistered) {
            return;
        }

        TableBuilderDisplayFilterDropDown.isRegistered = true;

        for (let element of document.querySelectorAll(TableBuilderDisplayFilterDropDown.selector)) {
            new TableBuilderDisplayFilterDropDown(element as HTMLElement);
        }
    }

    /**
     * Select toggle event listener.
     * When user press toggle button, all list items (checkbox) will be checked or unchecked
     * @param {event} KeyboardEvent
     */
    onSelectAllToggle = (event:Event) => {
        event.stopPropagation();
        this.toggleSelections(this.toggled);
        this.toggleLabels(this.toggled);
    }
    
    /**
     * Toggle drop down list item checkbox selections
     * @param {boolean} toggled Toggle all or not to toggle
     */
    toggleSelections = (toggled:boolean) => {
        const dropDownMenuItems = this.element.querySelectorAll('.dropdown-menu input[type=checkbox]');
        for (let menuItem of dropDownMenuItems) {
            let checkboxInput = <HTMLInputElement> menuItem;
            checkboxInput.checked = !toggled;
        }
        this.toggled = !toggled;
        if (this.element.hasAttribute('data-defaults-to-all'))
            this.updateInputNames();
    }

    /**
     * The server selects every item when the filter is missing from the request, so when all items are
     * checked, the checkboxes lose their name and stay out of the form data. When most items are checked,
     * the unchecked values are sent as <name>__exclude instead. Otherwise long lists (locations,
     * technicians) made the table search URL longer than the server accepts.
     */
    updateInputNames = () => {
        const checkboxInputs = <NodeListOf<HTMLInputElement>> this.element.querySelectorAll('.dropdown-menu input[type=checkbox]');
        let unchecked: HTMLInputElement[] = [];
        for (let checkboxInput of checkboxInputs) {
            if (!checkboxInput.hasAttribute('data-name'))
                checkboxInput.setAttribute('data-name', checkboxInput.getAttribute('name'));
            if (!checkboxInput.checked)
                unchecked.push(checkboxInput);
        }

        for (let excludedInput of this.element.querySelectorAll('input[data-excluded-value]'))
            excludedInput.parentNode.removeChild(excludedInput);

        const sendExcluded = unchecked.length < checkboxInputs.length - unchecked.length;
        for (let checkboxInput of checkboxInputs) {
            if (sendExcluded)
                checkboxInput.removeAttribute('name');
            else
                checkboxInput.setAttribute('name', checkboxInput.getAttribute('data-name'));
        }

        if (sendExcluded) {
            for (let checkboxInput of unchecked) {
                const excludedInput = document.createElement('input');
                excludedInput.type = 'hidden';
                excludedInput.name = checkboxInput.getAttribute('data-name') + '__exclude';
                excludedInput.value = checkboxInput.value;
                excludedInput.setAttribute('data-excluded-value', '');
                this.element.appendChild(excludedInput);
            }
        }
    }

    /**
     * Change toggle button label based toggle flag
     * @param {boolean} toggled Toggle all or not to toggle
     */
    toggleLabels = (toggled:boolean) => {
        let toggleButton = <HTMLButtonElement> this.element.querySelector('.select-all-toggle');
        const selectAllText = <HTMLSpanElement> toggleButton.querySelector('[data-select-all]');
        selectAllText.classList.toggle('hidden', !toggled)
        const unselectAllText = <HTMLSpanElement> toggleButton.querySelector('[data-clear-selection]');
        unselectAllText.classList.toggle('hidden', toggled)
    }

    /**
     * Filter input keyboard listener
     * @param {event} KeyboardEvent
     */
    onListFilterKeyUp = (event:KeyboardEvent) => {
        let filterInput = <HTMLInputElement> event.srcElement;
        let filter = filterInput.value.trim().toLowerCase();
        const dropDownMenuItems = this.element.querySelectorAll('.dropdown-menu .item');
        for (var i = 0; i < dropDownMenuItems.length; i++) {
            let menuItem = dropDownMenuItems[i] as HTMLSpanElement;
            let labelElement = <HTMLLabelElement> menuItem.querySelector('label')
            let text = labelElement.innerText.toLowerCase();
            if (text.indexOf(filter) > -1) {
                menuItem.style.display = '';   
            } else {
                menuItem.style.display = 'none';    
            }
        }
    }
}